'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttrsGtm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCookie = getCookie;
exports.headerBifrostAu = headerBifrostAu;
exports.defaultHeaders = defaultHeaders;
exports.http = http;
exports.isSafari = isSafari;
exports.parseJSON = parseJSON;
exports.request = request;

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function headerBifrostAu() {
  var headers = {};
  // if (isSafari()) {
  var xBifrostAu = getCookie('Valgrind-AU');
  if (xBifrostAu) {
    headers['X-Bifrost-Authorization'] = xBifrostAu;
  }
  // }

  return headers;
}

function defaultHeaders() {
  var apikey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var bifrost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _extends({
    Accept: 'application/json',
    'content-type': 'application/json'
  }, apikey ? { 'X-Application-Key': apikey } : null, bifrost ? { 'X-Bifrost-Authorization': bifrost } : null);
}

function http(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, _extends({
    method: 'GET',
    // credentials: 'include',
    mode: 'cors'
  }, options)).then(function (response) {
    var contentType = response.headers.get("content-type");
    if (response.ok) {
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      }

      return response;
    }
  });
}

function isSafari() {
  return navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
}

function parseJSON(json) {
  try {
    return json !== '' ? JSON.parse(json) : '';
  } catch (error) {
    return json;
  }
}

function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var headers = options.headers || {};
  var method = options.method || 'GET';

  var state = _store2.default.getState();

  var req = new XMLHttpRequest();

  req.open(method, '' + url);
  req.setRequestHeader('Content-Type', 'application/json');

  Object.keys(headers).forEach(function (key) {
    req.setRequestHeader(key, headers[key]);
  });

  if (options.type === _constants.ECRED) {
    var apiKey = state.heimdall.ecred.apiKey;

    req.setRequestHeader('X-Application-Key', apiKey);
  } else {
    req.withCredentials = true;
  }

  if (state.profile) {
    req.setRequestHeader('X-Bifrost-Authorization', state.profile.token);
  }

  req.onreadystatechange = function () {
    if (req.readyState < 4) {
      return;
    }

    callback(req.status < 200 || req.status > 299, {
      status: req.status,
      responseText: req.responseText,
      response: parseJSON(req.responseText)
    });
  };

  req.send();
}

var getAttrsGtm = exports.getAttrsGtm = function getAttrsGtm(name, params) {
  var _ref = params || {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'click' : _ref$type,
      _ref$clicktype = _ref.clicktype,
      clicktype = _ref$clicktype === undefined ? 'link' : _ref$clicktype;

  return {
    "data-gtm-type": type,
    "data-gtm-clicktype": clicktype,
    "data-gtm-name": name
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/utils.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38